<div class="d-flex position-relative">
  <atx-image
    class="img-fluid my-2 mx-2"
    [imageUrl]="product.mainImageUrl"
    [maxWidth]="imageMaxSizes.THUMBNAIL"
    data-e2e="current-media"
    fallbackImageUrl="static/images/placeholder-image.jpg"
    borderRadius="true"
  >
  </atx-image>

  <div class="product-details-wrapper" [class.expanded]="expanded$$ | async">
    <div class="d-flex flex-column p-2 pl-0 product-details">
      <div class="d-flex flex-column mb-1">
        <span
          *ngIf="product | productTitle: { fields: idFields } as productId"
          class="text-muted"
        >
          {{ productId }}
        </span>
        <span
          *ngIf="
            product | productTitle: { fields: titleFields } as productTitle
          "
          class="pcard-title text-truncate font-weight-bold mb-2"
          [title]="productTitle"
          ellipsisTextClass="text-body"
          data-e2e="pcard-title"
          >{{ productTitle }}</span
        >
      </div>
      <atx-product-prices
        class="product-prices flex-row-reverse justify-content-between"
        [prices]="price"
      ></atx-product-prices>
    </div>
  </div>
  <ng-container *ngIf="!product.isAvailable">
    <div
      class="position-absolute inset-cover unavailable pointer-events-none"
    ></div>
  </ng-container>
</div>

<div class="d-flex flex-column border-left">
  <button
    class="add-to-list-button btn ml-auto p-1"
    (click)="addToListClicked.next(product)"
  >
    <fa-icon [icon]="addToListIcon$ | async" size="1x"></fa-icon>
  </button>
</div>
